import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const OurPartners = () => {
  const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 5 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 3 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  const clientLogos = [
    "/images/vendor-1.jpg",
    "/images/vendor-2.jpg",
    "/images/vendor-3.jpg",
    "/images/vendor-4.jpg",
    "/images/vendor-5.jpg",
    "/images/vendor-6.jpg",
    "/images/vendor-7.jpg",
    "/images/vendor-8.jpg",
    "/images/vendor-9.jpg",
  ];

  return (
    <section className="py-16 bg-gradient-to-r from-gray-50 to-gray-100">
      <div className="container mx-auto text-center">
        {/* Title */}
        <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight mb-3">
          Trusted By <span className="text-primary">Our Partners</span>
        </h2>
        <p className="text-gray-600 mb-10 max-w-2xl mx-auto">
          Collaborating with leading organizations to co-create value and deliver excellence.
        </p>

        {/* Carousel */}
        <Carousel
          ssr
          infinite
          autoPlay
          autoPlaySpeed={2500}
          responsive={responsive}
          arrows={false}
          draggable
          swipeable
          keyBoardControl
          transitionDuration={600}
          containerClass="carousel-container"
          itemClass="px-3"
        >
          {clientLogos.map((logo, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg p-6 flex items-center justify-center 
                         transition-transform transform hover:scale-105 hover:shadow-2xl"
            >
              <img
                src={logo}
                alt={`Partner ${index + 1}`}
                className="h-20 object-contain mix-blend-multiply"
              />
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
};

export default OurPartners;
